module.exports = __webpack_public_path__ + "img/zona_camastros.a89d271e.jpg";